import {useAtomValue} from 'jotai';

import {OmicronFlags} from '@web-catalog/api/omicronApi/types';

import {
  omicronConfigAtom,
  omicronConfigClientAtom,
} from '@web-catalog/store/omicron';

/**
 * при сервер-сайд рендеринге вернет значение из фоллбека,
 * после гидрации на клиенте - актуальное (возможно еще и переопределенное кверей)
 */
export const useOmicronClientFlag = <T extends OmicronFlags>(
  omicronFlag: T,
) => {
  const omicronResponse = useAtomValue(omicronConfigClientAtom);

  return omicronResponse.config[omicronFlag];
};

/**
 * возвращает значение как пришло из омикрона без возможности переопределить кверей на клиенте
 */
export const useOmicronFlag = <T extends OmicronFlags>(omicronFlag: T) => {
  const omicronResponse = useAtomValue(omicronConfigAtom);

  return omicronResponse.config[omicronFlag];
};
